import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BUNDLES = [
    {
        id: 'essential', title: "La Cuvée Essentielle", price: "2 490 €", color: "#3b82f6",
        desc: "Pour une présence élégante et maîtrisée.",
        features: ["Site Vitrine 5 Pages", "Design Responsive", "Formulaire Contact", "Hébergement Sécurisé"]
    },
    {
        id: 'pro', title: "Le Millésime Pro", price: "4 990 €", color: "#8b5cf6", popular: true,
        desc: "La référence pour dominer votre marché.",
        features: ["Tout l'Essentiel +", "Référencement SEO Avancé", "Blog / Actualités", "Module de Réservation", "Formation Admin"]
    },
    {
        id: 'custom', title: "L'Exception", price: "Sur Devis", color: "#f59e0b",
        desc: "Une œuvre d'art digitale sur-mesure.",
        features: ["Architecture 100% Custom", "Fonctionnalités Métier", "E-Commerce / Espace Membre", "Direction Artistique Premium"]
    }
];

export default function CommercialBundlesPage() {
    const navigate = useNavigate();
    const [selected, setSelected] = useState(null);

    return (
        <div style={{ minHeight: '100vh', width: '100vw', background: '#0f172a', color: 'white', fontFamily: 'Inter, sans-serif', padding: 40, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

            <div style={{ textAlign: 'center', marginBottom: 60 }}>
                <div style={{ fontSize: '3rem', marginBottom: 10 }}>🍷</div>
                <h1 style={{ fontSize: '2.5rem', fontWeight: 900 }}>Le Sommelier</h1>
                <p style={{ opacity: 0.6, fontSize: '1.2rem' }}>Choisissez l'excellence qui convient à votre ambition.</p>
            </div>

            <div style={{ display: 'flex', gap: 30, flexWrap: 'wrap', justifyContent: 'center', maxWidth: 1200 }}>
                {BUNDLES.map(bundle => (
                    <div
                        key={bundle.id} onClick={() => setSelected(bundle.id)}
                        className="card-hover"
                        style={{
                            width: 350, background: selected === bundle.id ? 'white' : 'rgba(255,255,255,0.05)',
                            color: selected === bundle.id ? 'black' : 'white',
                            borderRadius: 24, padding: 40, cursor: 'pointer', position: 'relative',
                            border: `1px solid ${selected === bundle.id ? bundle.color : 'rgba(255,255,255,0.1)'}`,
                            transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
                            transform: selected === bundle.id ? 'scale(1.05) translateY(-10px)' : 'scale(1)'
                        }}
                    >
                        {bundle.popular && (
                            <div style={{ position: 'absolute', top: -15, left: '50%', transform: 'translateX(-50%)', background: '#8b5cf6', color: 'white', padding: '5px 15px', borderRadius: 20, fontSize: '0.8rem', fontWeight: 700 }}>
                                LE CHOIX DES EXPERTS
                            </div>
                        )}

                        <h2 style={{ fontSize: '1.8rem', fontWeight: 800, marginBottom: 10, color: selected === bundle.id ? bundle.color : 'white' }}>{bundle.title}</h2>
                        <div style={{ fontSize: '0.9rem', opacity: 0.7, marginBottom: 30, fontStyle: 'italic' }}>{bundle.desc}</div>

                        <div style={{ fontSize: '2.5rem', fontWeight: 900, marginBottom: 40 }}>{bundle.price}</div>

                        <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: 15 }}>
                            {bundle.features.map((feat, idx) => (
                                <li key={idx} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: '1rem', fontWeight: 500 }}>
                                    <span style={{ color: bundle.color }}>✓</span> {feat}
                                </li>
                            ))}
                        </ul>

                        <div style={{ marginTop: 40, textAlign: 'center' }}>
                            <button style={{ padding: '15px 30px', borderRadius: 50, border: 'none', background: bundle.color, color: 'white', fontWeight: 800, cursor: 'pointer', opacity: selected === bundle.id ? 1 : 0.5 }}>
                                SÉLECTIONNER
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {selected && (
                <div className="animate-fade-up" style={{ marginTop: 60, textAlign: 'center' }}>
                    <div style={{ fontSize: '1.2rem', marginBottom: 20 }}>Excellent choix.</div>
                    <button onClick={() => navigate('/commercial/sign')} style={{ padding: '20px 60px', borderRadius: 50, border: 'none', background: 'white', color: 'black', fontSize: '1.5rem', fontWeight: 900, cursor: 'pointer' }}>
                        VALIDER CE PACK ✒️
                    </button>
                </div>
            )}
            <button onClick={() => navigate('/commercial/launchpad')} style={{ position: 'fixed', bottom: 30, left: 30, background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.3)', cursor: 'pointer' }}>Retour</button>

            <style>{`.card-hover:hover { transform: translateY(-5px); } .animate-fade-up { animation: fadeUp 0.5s ease-out; } @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }`}</style>
        </div>
    );
}
